//should be exported to constants/sort.js
export const FROM_NEWER_TO_OLDER = 'FROM_NEWER_TO_OLDER';
export const FROM_OLDER_TO_NEWER = 'FROM_OLDER_TO_NEWER';

// helpers/sortByDate.js
// Always returns an array. Never mutates the input.
// Baked-in fallback keys: tries each until one yields a valid date.
// If none work for ANY item, returns the original array (copy) unchanged.

const DEFAULT_DATE_KEYS = [
  // very common
  'scheduled_at', 'createdAt', 'updatedAt',
  // snake_case
  'created_at', 'updated_at',
  // generic
  'publishedAt', 'postedAt', 'scheduledAt',
  'date', 'timestamp', 'time'
];

export function sortByDate(data, opts = {}) {
  const {
    key = undefined,          // single key; if null -> sort raw item; if undefined -> use defaults
    keys = undefined,         // custom fallback list
    order = 'desc',           // 'asc' | 'desc'
    coerce = (v) => v,        // transform before Date (e.g., parse ISO)
  } = opts;

  const arr = Array.isArray(data) ? data.filter(Boolean) : [];

  // Build the priority list of keys to try.
  // Priority: explicit keys[] > single key > baked defaults.
  let keysToTry;
  if (key === null) {
    keysToTry = []; // raw item mode
  } else if (Array.isArray(keys) && keys.length) {
    keysToTry = dedupe(keys.concat(DEFAULT_DATE_KEYS));
  } else if (typeof key === 'string' && key) {
    keysToTry = dedupe([key].concat(DEFAULT_DATE_KEYS));
  } else {
    keysToTry = DEFAULT_DATE_KEYS.slice();
  }

  const toTs = (item) => {
    if (keysToTry.length === 0) {
      const d = new Date(coerce(item));
      const t = d.getTime();
      return Number.isNaN(t) ? NaN : t;
    }
    for (const k of keysToTry) {
      const raw = item?.[k];
      if (raw == null) continue;
      const d = new Date(coerce(raw));
      const t = d.getTime();
      if (!Number.isNaN(t)) return t;
    }
    return NaN;
  };

  const pairs = arr.map((it, i) => [it, toTs(it), i]);
  const hasValid = pairs.some(([, ts]) => !Number.isNaN(ts));
  if (!hasValid) return arr.slice(); // unchanged order

  pairs.sort((a, b) => {
    const [, ta, ia] = a;
    const [, tb, ib] = b;

    const aNaN = Number.isNaN(ta);
    const bNaN = Number.isNaN(tb);
    if (aNaN && bNaN) return ia - ib;   // keep original order
    if (aNaN) return 1;                 // invalid go last
    if (bNaN) return -1;

    const cmp = ta - tb;
    if (cmp === 0) return ia - ib;      // stable
    return order === 'asc' ? cmp : -cmp;
  });

  return pairs.map(([it]) => it);
}

function dedupe(list) {
  const seen = new Set();
  const out = [];
  for (const k of list) {
    if (k && !seen.has(k)) { seen.add(k); out.push(k); }
  }
  return out;
}

